import React, { useContext, useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import { useHistory } from "react-router";
import jwtDecode from "jwt-decode";
import {
  CognitoUserPool,
  CognitoUser,
  CognitoAccessToken,
  CognitoIdToken,
  CognitoRefreshToken,
  CognitoUserSession
} from 'amazon-cognito-identity-js';
import { ENV } from "../../environments/env";
import {
  ApplicationContext,
  ProviderContextProvider,
} from "../../ApplicationState";
import { AuthState } from "@aws-amplify/ui-components";
import { getUserAttributes } from "../../services/Helpers";

const AuthCallback: React.FC = () => {
  const { userState, setUserState } = useContext(ApplicationContext);
  const [user, setUser] = React.useState<any | undefined>(undefined);
  const [userAttributes, setUserAttributes] = React.useState<any | undefined>(
    undefined
  );


  const history = useHistory();

  async function setCognitoSessionManually({ idToken, accessToken, refreshToken }) {
    // Create token objects
    const accessTokenObj = new CognitoAccessToken({ AccessToken: accessToken });
    const idTokenObj = new CognitoIdToken({ IdToken: idToken });
    const refreshTokenObj = new CognitoRefreshToken({ RefreshToken: refreshToken });

    // Create full session
    const session = new CognitoUserSession({
      IdToken: idTokenObj,
      AccessToken: accessTokenObj,
      RefreshToken: refreshTokenObj,
    });

    // Create Cognito user object
    const poolData = {
      UserPoolId: `${ENV.AWS_USER_POOL_ID}`,
      ClientId: `${ENV.AWS_USER_POOL_WEBCLIENT_ID}`
    };

    // Extract username from access token instead of id token
    const accessTokenPayload = JSON.parse(atob(accessToken.split(".")[1]));
    const username = accessTokenPayload["sub"] || accessTokenPayload["cognito:sub"];

    if (!username) {
      throw new Error("Username not found in access token payload");
    }
    const userPool = new CognitoUserPool(poolData);
    const userData = {
      Username: username,
      Pool: userPool
    };
    const cognitoUser = new CognitoUser(userData);

    // Manually set the session
    cognitoUser.setSignInUserSession(session);

    // Persist in Amplify’s cache so Auth.currentSession() works
    const authenticatedUser = await Auth.currentUserPoolUser(); // Ensures Amplify knows the user
    localStorage.setItem(
      `CognitoIdentityServiceProvider.${poolData.ClientId}.${cognitoUser.getUsername()}.idToken`,
      idToken
    );
    localStorage.setItem(
      `CognitoIdentityServiceProvider.${poolData.ClientId}.${cognitoUser.getUsername()}.accessToken`,
      accessToken
    );
    localStorage.setItem(
      `CognitoIdentityServiceProvider.${poolData.ClientId}.${cognitoUser.getUsername()}.refreshToken`,
      refreshToken
    );

    console.log('✅ Cognito session set manually.');

    return authenticatedUser;
  }
  useEffect(() => {
    const handleAuthCallback = async () => { // Define an async function inside
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const encodedTokens = urlParams.get("tokens");
        if (!encodedTokens) {
          history.replace("/");
          return;
        }

        const decodedOnce = decodeURIComponent(encodedTokens);
        const innerParams = new URLSearchParams(decodedOnce);
        const accessToken = innerParams.get("access_token");
        const idToken = innerParams.get("id_token");
        const refreshToken = innerParams.get("refresh_token");
        // console.log("********************here*****************");
        // console.log(accessToken);
        // console.log(idToken);
        // console.log(refreshToken);
        if (accessToken) {
          const authenticatedUser = await setCognitoSessionManually({ idToken, accessToken, refreshToken });
          setUserState({ authenticatedUser: authenticatedUser });
          //   console.log(authenticatedUser);
          //   console.log(authenticatedUser.signInUserSession.idToken);
          //   console.log(authenticatedUser.signInUserSession.idToken.jwtToken);
          setUser(authenticatedUser);
          setUserAttributes(
            getUserAttributes(jwtDecode(authenticatedUser.signInUserSession.idToken.jwtToken))
          );

          window.location.href = "/";
        } else {
          console.error("Tokens not found in URL");
          history.replace("/");
        }
      } catch (error) {
        console.error("Error during authentication callback:", error);
        history.replace("/error");
      }
    };
    handleAuthCallback(); // Call the async function immediately
  }, []);
  localStorage.setItem("LOGIN_NAME", 'CLIN_REPO')
  return <div>Completing login...</div>;
};

export default AuthCallback;
